import exclusiveMitraSendMoneyApi from 'shared_js/api/exclusiveApi/exclusiveMitraSendMoneyApi';
import exclusiveQrisApi from 'shared_js/api/exclusiveApi/exclusiveQrisApi';
import exclusivePinApi from 'shared_js/api/exclusiveApi/exclusivePinApi';
import publicUserApi from 'shared_js/api/publicApi/publicUserApi';
import logger from 'shared_js/modules/logger/logger';

import { LOADING, LOADED, ERROR } from 'shared_js/constants/commonStatuses';

import {
  SET_SEND_MONEY_USER_INFO,
  SET_PHONE_NUMBER,
  SET_LOADING_STATUS,
  SET_VALID_SALES_CODE,
  SET_OOM_FLOW_ELIGIBILITY,
  SET_QRIS_USER_INFO,
  SET_QRIS_BLUE_BOX_FIRST_DATE,
  SET_HAS_PIN,
} from './mutationTypes';

const QRIS_BLUE_BOX_FIRST_DATE_LOCAL_STORAGE = 'qrisBlueBoxFirstDate';

export default {
  async getSendMoneyUserInfo({ commit }) {
    try {
      commit(SET_LOADING_STATUS, LOADING);
      const response = await exclusiveMitraSendMoneyApi.inquiryUserMitraSendMoney();
      commit(SET_SEND_MONEY_USER_INFO, response.data);
      commit(SET_VALID_SALES_CODE, response.data.valid_sales_code || false);
      commit(SET_OOM_FLOW_ELIGIBILITY, response.data.buka20_flow || false);
      commit(SET_LOADING_STATUS, LOADED);
    } catch (e) {
      logger.log(e);
      commit(SET_LOADING_STATUS, ERROR);
      throw e;
    }
  },
  async updateSendMoneyUserInfo({ commit }, params) {
    try {
      const response = await exclusiveMitraSendMoneyApi.updateMitraStatus(
        params,
      );
      commit(SET_SEND_MONEY_USER_INFO, response.data);
    } catch (e) {
      logger.log(e);
      throw e;
    }
  },
  async saveActivationStatus(context, params) {
    try {
      await exclusiveMitraSendMoneyApi.saveActivationStatus(params);
    } catch (e) {
      logger.log(e);
      throw e;
    }
  },
  async createUserTrial({ commit }) {
    try {
      const response = await exclusiveMitraSendMoneyApi.createUserTrial();
      commit(SET_SEND_MONEY_USER_INFO, response.data);
    } catch (e) {
      logger.log(e);
      throw new Error('fail-create-user-trial');
    }
  },
  async retrieveSingleKycIdentity() {
    try {
      const response = await exclusiveMitraSendMoneyApi.retrieveSingleKycIdentity();
      return response.data;
    } catch (e) {
      logger.log(e);
      throw e;
    }
  },
  async getPhoneNumber({ commit }) {
    try {
      commit(SET_LOADING_STATUS, LOADING);
      const response = await publicUserApi.getAccountUserInfo();
      commit(SET_PHONE_NUMBER, response.data.phone);
      commit(SET_LOADING_STATUS, LOADED);
    } catch (e) {
      logger.log(e);
      commit(SET_LOADING_STATUS, ERROR);
      throw e;
    }
  },

  // blue box qris information
  async getQrisUserInfo({ commit, dispatch }) {
    try {
      const { data } = await exclusiveQrisApi.retrieveUserInfo();
      commit(SET_QRIS_USER_INFO, data);
      dispatch('getQrisBlueBoxFirstDate');
    } catch (e) {
      logger.log(e);
      throw e;
    }
  },
  getQrisBlueBoxFirstDate({ commit }) {
    const firstDate =
      localStorage.getItem(QRIS_BLUE_BOX_FIRST_DATE_LOCAL_STORAGE) ?? '';
    commit(SET_QRIS_BLUE_BOX_FIRST_DATE, firstDate);
  },
  setQrisBlueBoxFirstDate({ commit, state }) {
    if (state.qrisBlueBoxFirstDate === '') {
      const firstDate = new Date().toISOString();
      commit(SET_QRIS_BLUE_BOX_FIRST_DATE, firstDate);
      localStorage.setItem(QRIS_BLUE_BOX_FIRST_DATE_LOCAL_STORAGE, firstDate);
    }
  },

  // pin
  async getPINStatus({ commit }) {
    try {
      const { data } = await exclusivePinApi.retrievePinStatus();
      commit(SET_HAS_PIN, data.status === 'active');
    } catch {
      //
    }
  },
};
